import { useState } from 'react';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'people', label: 'People' },
  { id: 'teams', label: 'Teams' },
  { id: 'schedule', label: 'Master Schedule' },
  { id: 'meals', label: 'Meal Counts' },
];

function OverviewPane() {
  return (
    <>
      <div className="notice-bar">This is a read-only archive. No edits can be made to 2025 data.</div>
      <div className="stat-grid">
        <div className="stat-card"><div className="stat-label">Registered</div><div className="stat-value">861</div><div className="stat-sub">final count</div></div>
        <div className="stat-card"><div className="stat-label">Teams</div><div className="stat-value">24</div><div className="stat-sub">fully rostered</div></div>
        <div className="stat-card"><div className="stat-label">Multi-Team</div><div className="stat-value">98</div><div className="stat-sub">served 2–3 teams</div></div>
        <div className="stat-card"><div className="stat-label">Conference Days</div><div className="stat-value">3</div><div className="stat-sub">June 2025</div></div>
      </div>
    </>
  );
}

function PeoplePane() {
  return (
    <div className="panel">
      <table className="data-table">
        <thead><tr><th>Name</th><th>Teams</th><th>Pass Level</th><th>Status</th></tr></thead>
        <tbody>
          <tr style={{ cursor: 'default' }}>
            <td><span className="td-name">Daniel Smith</span></td>
            <td>Concourse Team · Photo + Video</td>
            <td><span className="pill pill-gray">SL</span></td>
            <td><span className="status-dot dot-green" />Rostered</td>
          </tr>
          <tr style={{ cursor: 'default' }}>
            <td><span className="td-name">Marcus Williams</span></td>
            <td>Worship / Band · Photo + Video · Security</td>
            <td><span className="pill pill-dark">AA</span></td>
            <td><span className="status-dot dot-green" />Rostered</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function TeamsPane() {
  return (
    <div className="panel">
      <div className="team-grid">
        <div className="team-card" style={{ cursor: 'default' }}>
          <div className="team-card-name">Worship / Band</div>
          <div className="team-card-meta">Lead: Marcus Williams</div>
          <div className="team-card-count">46</div>
        </div>
        <div className="team-card" style={{ cursor: 'default' }}>
          <div className="team-card-name">Concourse Team</div>
          <div className="team-card-meta">Lead: Tony Reeves</div>
          <div className="team-card-count">52</div>
        </div>
      </div>
    </div>
  );
}

function SchedulePane() {
  return (
    <div className="panel">
      <div className="schedule-day">
        <div className="day-label">Thursday, June 5, 2025</div>
        <div className="schedule-item">
          <div className="schedule-time">7:00 AM</div>
          <div className="schedule-detail"><div className="schedule-name">Shuttle Depart</div><div className="schedule-loc">Hotel Lobby</div></div>
        </div>
        <div className="schedule-item">
          <div className="schedule-time">8:30 AM</div>
          <div className="schedule-detail"><div className="schedule-name">All-Hands Briefing</div><div className="schedule-loc">Main Auditorium</div></div>
        </div>
      </div>
    </div>
  );
}

function MealsPane() {
  return (
    <div className="stat-grid" style={{ gridTemplateColumns: 'repeat(3,1fr)' }}>
      <div className="stat-card"><div className="stat-label">Thursday Total</div><div className="stat-value">574</div></div>
      <div className="stat-card"><div className="stat-label">Friday Total</div><div className="stat-value">643</div></div>
      <div className="stat-card"><div className="stat-label">Saturday Total</div><div className="stat-value">489</div></div>
    </div>
  );
}

const PANE_MAP = {
  overview: OverviewPane,
  people: PeoplePane,
  teams: TeamsPane,
  schedule: SchedulePane,
  meals: MealsPane,
};

export default function AdminPast() {
  const [activeTab, setActiveTab] = useState('overview');
  const PaneComponent = PANE_MAP[activeTab];

  return (
    <>
      <div style={{ padding: '20px 40px 0', background: 'var(--white)', borderBottom: '1px solid var(--border)' }}>
        <div className="page-title-row" style={{ marginBottom: 0, paddingBottom: 0 }}>
          <div>
            <div className="page-title">2025 Conference</div>
            <div className="page-sub">The Belonging Co Conference · 2025</div>
          </div>
          <span className="pill pill-gray" style={{ fontSize: 11, padding: '6px 14px' }}>Archived — Read Only</span>
        </div>
        <div style={{ display: 'flex', marginTop: 16 }}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`tv-tab${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className="page-content">
        <PaneComponent />
      </div>
    </>
  );
}
